import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { useParams, useLocation, useNavigate } from "react-router";
import { Column } from "primereact/column";
import { APP_BASE_URL, cycleStatusDropdown, paySchemaOptions, provinces } from "../../appconfig/Settings";
import axiosInstance from "../../config/axiosInstance";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { OverlayPanel } from "primereact/overlaypanel";

import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { ClientListColumns, ClientListColumnsByUser, ClientListColumnsForUser } from "../../appconfig/DatatableSetting";
import { deleteData, getSpecificDetails, postAllData, updateData } from "../../service/ProductService";
import { DELETE_CLIENT, GET_CLIENT_LIST, GET_USER_DETAIL, GET_USER_LIST, SAVE_CLIENT_DATA, UPDATE_CLIENT_DATA } from "../../config/ApiConstant";
import { dateMonthYearTemplate, globalFieldTemplate, userTemplate } from "../../appconfig/TemplateFieldSetting";
import { validateClientForm } from "../../config/Validate";
import { Link } from "react-router-dom";
import { Card } from "primereact/card";
import moment from "moment";
import { InputNumber } from "primereact/inputnumber";
import { globalNameFilterTemplate } from "../../appconfig/AppHelper";
import Loader from "../../components/Loader/Loader";
import { Badge } from "primereact/badge";
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import UpdatePaymentMethod from "../../components/BankDetails/BankDetails";
import { Checkbox } from "primereact/checkbox";

const ManageClients = () => {
  document.title = "Clients | Nexawage Payroll";
  const toast = useRef<any>(null);
  const location = useLocation();
  const navigate = useNavigate();

  const { id }: any = useParams();
  // const user_id = atob(id);
  const user_id = id
    ? (() => {
      try {
        return atob(id);
      } catch {
        return null;
      }
    })()
    : null;
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<any>(null);
  const [clientList, setClientList] = useState<any>([]);
  const [userHead, setUserHead] = useState<any>([]);
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false);
  const [addDeleteClientDialog, setAddDeleteClientDialog] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<any>(null);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [category, setCategory] = useState<any>(null);
  const [cycleStatus, setCycleStatus] = useState<any>(null);
  const currentYear = moment().year();

  // state for business number to display static
  const [displayBusinessNumber, setDisplayBusinessNumber] = useState("");

  // current month and year to select client payment start date
  const [clientCurrentMonthYear, setClientCurrentMonthYear] = useState<any>();

  // client payment field min date selected
  const [clientPaymentMinDate, setClientPaymentMinDate] = useState<any>(null);

  //set supervisor
  const [supervisor, setSupervisor] = useState<any>(null);
  const [supervisorOptions, setSupervisorOptions] = useState<any[]>([]);
  const [loadingSupervisors, setLoadingSupervisors] = useState<boolean>(false);

  // dialog to display info about card detail added by user or not
  const [userCardInfoDialog, setUserCardInfoDialog] = useState<boolean>(false);

  // flag to display model when adding client without adding bank card detail
  const bank_detail_added: any = localStorage.getItem("payment_details_added");

  // check that card details are added by user or not
  const [cardDetailsAddedByUser, setCardDetailsAddedByUser] = useState<any>();

  // disable client payment start date field based on current month yaer and client_subs_month_year (in edit time)
  const [disableClientPaymentStartDateOnEdit, setDisableClientPaymentStartDateOnEdit] = useState<boolean>(false);

  // action body template selected row
  const [clickedRow, setClickedRow] = useState<any>();

  // state for pay scheme change confirmation
  const [paySchemaConfirmation, setPaySchemaConfirmation] = useState<boolean>(false);

  // state to store original pay scheme values for comparison
  const [originalPaySchemeData, setOriginalPaySchemeData] = useState<any>({ pay_schema: null, bi_weekly_start_date: null, custom_bi_weekly: null });

  // ref for overlypanel
  const dropdownButton = useRef<OverlayPanel>(null);

  // useEffect to get data
  useEffect(() => {
    getClientList();
    // loadSupervisors();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, supervisor]);

  // client detail obj
  const [globleClientData, setGlobalClientData] = useState<any>({
    client_charge: "9.99",
  });
  const isSchemeChanged = isEdit && (
    globleClientData.pay_schema !== originalPaySchemeData.pay_schema ||
    globleClientData.custom_bi_weekly !== originalPaySchemeData.custom_bi_weekly ||
    (globleClientData.pay_schema === "Bi Weekly" &&
      (globleClientData.bi_weekly_start_date || "") !== (originalPaySchemeData.bi_weekly_start_date || ""))
  );


  // stripe card detail form model
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";
  const userId = userData?.id;

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    company_name: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    name: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    user: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    pay_schema: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    cycle_status: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    client_subs_month_year: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
    client_payroll_starts_from: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
    email: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    phone: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  //Id Wise Check Datatable Columne

  let clientListCol = userRole === "User" ? ClientListColumnsForUser : userRole === "Admin" && !user_id ? ClientListColumns : ClientListColumnsByUser;

  // setting business number for display purpose static
  useEffect(() => {
    if (globleClientData.bussiness_number) {
      const val = globleClientData.bussiness_number;
      const firstNine = val.slice(0, 9);
      const rest = val.slice(9);
      const displayVal = val.length > 9 ? `${firstNine} RP ${rest}` : val;
      setDisplayBusinessNumber(displayVal);
    }
  }, [globleClientData.bussiness_number]);

  // useeffect for selecting payment_start_date minDate when adding client for first time
  useEffect(() => {
    if (!isEdit) {
      // clear client payment start date field on change of paayroll start date field only when isEdit is false
      setGlobalClientData({ ...globleClientData, client_subs_month_year: "" });
      if (globleClientData?.client_payroll_starts_from) {
        setClientPaymentMinDate(globleClientData.client_payroll_starts_from);
      }
    }
  }, [globleClientData?.client_payroll_starts_from, clientCurrentMonthYear, isEdit]);

  // get supervisor
  const loadSupervisors = async () => {
    if (supervisorOptions.length > 0 || loadingSupervisors) return;
    try {
      setLoadingSupervisors(true);
      const response = await axiosInstance(APP_BASE_URL + GET_USER_LIST + "?type=User");
      const data = response?.data?.data;
      if (data) {
        const options = data.map((user: any) => ({
          ...user,
          value: user.id,
          name: `${user.first_name} ${user.last_name}`,
        }));
        setSupervisorOptions(options);
      } else {
        setSupervisorOptions([]);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
    } finally {
      setLoadingSupervisors(false);
    }
  };

  // get client list api
  const getClientList = async () => {
    try {
      setPageLoad(false);
      const response = !user_id
        ? await axiosInstance(APP_BASE_URL + GET_CLIENT_LIST + `?type=Client&supervisor_id=${supervisor}`)
        : await getSpecificDetails(GET_USER_DETAIL, user_id);

      //Check Id Base Response
      let data = user_id ? response : response?.data;

      //Check Id Base Response Set
      if (user_id && data) {
        setUserDetails(data?.Userdata);

        // check that card details added by user or not
        const payment_details_added = data?.Userdata?.payment_details_added;
        setCardDetailsAddedByUser(payment_details_added);

        // normalise date to convert into data object instead of string
        const apiClientListData = data?.Clientlist?.map((item: any) => ({
          ...item,
          client_subs_month_year: item?.client_subs_month_year ? new Date(item?.client_subs_month_year) : null,
          client_payroll_starts_from: item?.client_payroll_starts_from ? new Date(item?.client_payroll_starts_from) : null,
        }));
        setClientList(apiClientListData);
        setPageLoad(true);

        // set client month and year
        const input = data?.current_year_month;
        const formatted = moment(input, "MM/YYYY").format("YYYY-MM");
        setClientCurrentMonthYear(formatted);
      } else if (!user_id && data) {
        // normalise date to convert into data object instead of string
        const normalise = data?.data?.map((item: any) => ({
          ...item,
          client_subs_month_year: item?.client_subs_month_year ? new Date(item?.client_subs_month_year) : null,
          client_payroll_starts_from: item?.client_payroll_starts_from ? new Date(item?.client_payroll_starts_from) : null,
        }));

        setClientList(normalise);
        setUserDetails(null);
        setPageLoad(true);

        // set client month and year
        const input = data?.current_year_month;
        const formatted = moment(input, "MM/YYYY").format("YYYY-MM");
        setClientCurrentMonthYear(formatted);
      } else {
        setClientList([]);
        setUserDetails(null);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // client payment min Date template
  const clientPaymentDates = (rowData: any) => {
    let created_at = moment(rowData?.createdAt).format("YYYY-MM");
    let currentMonthYear = clientCurrentMonthYear;
    let minDatePayment;

    if (created_at == currentMonthYear) {
      minDatePayment = moment(clientCurrentMonthYear, "YYYY-MM-DD").add(0, "month").toDate();
    } else if (created_at != currentMonthYear) {
      minDatePayment = moment(clientCurrentMonthYear, "YYYY-MM-DD").add(0, "month").toDate();
    }

    return minDatePayment;
  };

  // clear all filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFieldFilter(null);
    setSupervisor(null);
    setGlobalFilter(null);
  };

  // global search filter on change
  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        {/* <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." /> */}
        <InputText type="search" value={globalFilter || ""} onChange={onGlobalFilterChange} placeholder="Search..." />
      </span>
      {/* 
      {userRole === "Admin" && !user_id && (
        <Dropdown
          value={supervisor}
          onChange={(e) => {
            setSupervisor(e.value);
          }}
          options={supervisorOptions}
          optionLabel="name"
          placeholder="Select Supervisor"
          className="order-drp ml-2 w-15rem"
        />
      )} */}
    </>
  );

  // handle client should be added or not based on card added by user or not
  const handleClientAdd = () => {
    if (userRole === "Admin") {
      if (userDetails?.payment_details_added == true) {
        addEditDialog();
      } else if (userRole === "Admin" && user_id == null) {
        addEditDialog();
      } else {
        setUserCardInfoDialog(true);
      }
    } else if (userRole === "User") {
      if (bank_detail_added == "true") {
        addEditDialog();
      } else {
        setUserCardInfoDialog(true);
      }
    }
  };

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <Button icon="pi pi-filter-slash" label="Clear" onClick={clearAll} className="mr-2 p-button-outlined common-p-outline-button" />
      {(userRole === "Admin" || userRole === "User") && (
        <Button className="ml-1 common-primary-button" icon="pi pi-plus" label="Add Client Data" onClick={() => handleClientAdd()} />
      )}
    </>
  );

  // delete confirmation modal
  const confirmDelete = (deleteID: any) => {
    setDeleteId(deleteID);
    setDeleteDialog(true);
  };

  // delete client api call
  const deleteClient = async () => {
    try {
      setSubmitLoading(true);
      const response = await deleteData(DELETE_CLIENT, deleteId);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: response.message,
        });
        hideDeleteDialog();
        getClientList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setSubmitLoading(false);
    }
  };

  // hide delete modal
  const hideDeleteDialog = () => {
    setDeleteDialog(false);
    setDeleteId(null);
  };

  // add and edit client modal
  // const addEditDialog = async (rowData: any = null) => {
  //   try {
  //     let userData = userHead;
  //     if (!id) {
  //       const response = await axiosInstance(APP_BASE_URL + GET_CLIENT_LIST + "?type=User");

  //       userData = response?.data?.data?.map((user: any) => ({
  //         name: `${user.first_name} ${user.last_name}`,
  //         id: user?.id,
  //         payment_details_added: user?.payment_details_added,
  //       }));
  //       setUserHead(userData);
  //     }

  //     if (rowData) {
  //       let pay_check: any = "";

  //       // client payment start date
  //       let clientPaymentDate: any = moment(rowData?.client_subs_month_year, "YYYY-MM-DD").toDate();

  //       let payrollStartDate: any = moment(rowData?.client_payroll_starts_from, "YYYY-MM-DD").toDate();

  //       // pay check based on pay schema
  //       if (rowData?.pay_schema === "Bi Weekly") {
  //         pay_check = "Upcoming Friday";
  //       } else {
  //         pay_check = rowData?.paycheck;
  //       }

  //       // select supervisor based on rowdata
  //       const supervisorObject = userData?.find((user: any) => user?.id === rowData?.user?.id);

  //       setGlobalClientData({
  //         ...rowData,
  //         user_head: supervisorObject || null,
  //         paycheck: pay_check,
  //         ...(rowData?.client_subs_month_year ? { client_subs_month_year: clientPaymentDate } : undefined),
  //         ...(rowData?.client_payroll_starts_from ? { client_payroll_starts_from: payrollStartDate } : undefined),
  //       });

  //       setIsEdit(true);
  //     } else {
  //       setGlobalClientData({
  //         client_charge: "9.99",
  //       });
  //       setDisplayBusinessNumber("");
  //       setIsEdit(false);
  //     }

  //     setErrors({});

  //     // open edit dialog based on card details added by user or not
  //     if (userRole === "Admin") {
  //       if (cardDetailsAddedByUser === false && rowData && user_id) {
  //         setUserCardInfoDialog(true);
  //       } else {
  //         setAddDeleteClientDialog(true);
  //       }
  //     } else {
  //       setAddDeleteClientDialog(true);
  //     }
  //   } catch (error: any) {
  //     toast.current?.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: error.response?.data?.message,
  //     });
  //   }
  // };

  // add and edit client modal
  const addEditDialog = async (rowData: any = null) => {
    setPaySchemaConfirmation(false);
    try {
      let userData = userHead;
      if (!id) {
        const response = await axiosInstance(APP_BASE_URL + GET_CLIENT_LIST + "?type=User");

        userData = response?.data?.data.map((user: any) => ({
          name: `${user.first_name} ${user.last_name}`,
          id: user?.id,
          payment_details_added: user?.payment_details_added,
        }));
        setUserHead(userData);
      }

      if (rowData) {
        let pay_check: any = "";

        // Convert current month year to Date
        const currentMonthDate = moment(clientCurrentMonthYear, "YYYY-MM").toDate();

        // client payment start date
        let clientPaymentDate: any =
          rowData?.client_subs_month_year != null ? moment(rowData?.client_subs_month_year, "YYYY-MM-DD").toDate() : undefined;

        // payroll start date
        let payrollStartDate: any =
          rowData?.client_payroll_starts_from != null ? moment(rowData?.client_payroll_starts_from, "YYYY-MM-DD").toDate() : undefined;

        //  Set min date for calendar and also disable payment start date field according to clientPaymentDate and currentMonthDate
        if (clientPaymentDate != null && clientPaymentDate != undefined) {
          // check client_payment date is after current month year or same to disable client payment start date
          const isAfterCurrentMonth = moment(clientPaymentDate).isAfter(currentMonthDate, "month");

          // Disable when SAME or BEFORE current month
          setDisableClientPaymentStartDateOnEdit(!isAfterCurrentMonth);

          //  [ ckeck whether client payment date is after current month year to set min date ]

          // let paymentMinDate: any;
          // if (moment(currentMonthDate).isSame(clientPaymentDate, "month")) {
          //   paymentMinDate = currentMonthDate;
          // } else if (
          //   !moment(currentMonthDate).isSame(clientPaymentDate, "month")
          // ) {
          //   paymentMinDate = currentMonthDate;
          // }
          //  setClientPaymentMinDate(paymentMinDate);

          setClientPaymentMinDate(
            moment(clientPaymentDate).isAfter(currentMonthDate)
              ? moment(clientCurrentMonthYear, "YYYY-MM").add(1, "month").toDate()
              : currentMonthDate,
          );
        } else {
          setClientPaymentMinDate(moment(currentMonthDate).isAfter(payrollStartDate) ? currentMonthDate : payrollStartDate);
        }

        // pay check based on pay schema
        if (rowData?.pay_schema === "Bi Weekly") {
          pay_check = "Upcoming Friday";
        } else {
          pay_check = rowData?.paycheck;
        }

        // select supervisor based on rowdata
        const supervisorObject = userData?.find((user: any) => user?.id === rowData?.user?.id);

        setGlobalClientData({
          ...rowData,
          user_head: supervisorObject || null,
          paycheck: pay_check,
          ...(rowData?.client_subs_month_year ? { client_subs_month_year: clientPaymentDate } : undefined),
          ...(rowData?.client_payroll_starts_from ? { client_payroll_starts_from: payrollStartDate } : undefined),
        });

        setIsEdit(true);
        setOriginalPaySchemeData({
          pay_schema: rowData?.pay_schema,
          bi_weekly_start_date: rowData?.bi_weekly_start_date,
          custom_bi_weekly: rowData?.custom_bi_weekly === true,
        });
      } else {
        // Set min date for ADD
        setClientPaymentMinDate(moment(clientCurrentMonthYear, "YYYY-MM").toDate());

        setGlobalClientData({
          client_charge: "9.99",
        });
        setDisplayBusinessNumber("");
        setIsEdit(false);
        setOriginalPaySchemeData({ pay_schema: null, bi_weekly_start_date: null, custom_bi_weekly: null });
      }

      setErrors({});

      // open edit dialog based on card details added by user or not
      if (userRole === "Admin") {
        if (cardDetailsAddedByUser === false && rowData && user_id) {
          setUserCardInfoDialog(true);
        } else {
          setAddDeleteClientDialog(true);
        }
      } else {
        setAddDeleteClientDialog(true);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
    }
  };

  // hide add & edit client modal
  const hideAddEditClientDialog = () => {
    setAddDeleteClientDialog(false);
    setSubmitLoading(false);
    setGlobalClientData({});
    setDisableClientPaymentStartDateOnEdit(false);
    setPaySchemaConfirmation(false);
    setOriginalPaySchemeData({ pay_schema: null, bi_weekly_start_date: null, custom_bi_weekly: null });
    setErrors({});
  };

  // input change function
  const onInputChange = (e: any, name: string) => {
    let val: any;
    if (name === "vacation_hold" || name === "custom_bi_weekly") {
      val = e.checked ? true : false;
    } else if (name === "company_logo" && e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      const maxSize = 2 * 1024 * 1024; // 2MB

      if (!allowedTypes.includes(file.type)) {
        setErrors({ ...errors, company_logo: "Only JPG, JPEG, and PNG files are allowed" });
        return;
      }

      if (file.size > maxSize) {
        setErrors({ ...errors, company_logo: "File size must be less than 2MB" });
        return;
      }
      val = file;
    } else {
      val = e?.target?.value ?? e?.value;
    }

    if ((name === "bi_weekly_start_date" || name === "effective_date") && val) {
      val = moment(val).format("YYYY-MM-DD");
    }

    // clear client payment start from based on user head
    if (name === "user_head") {
      setGlobalClientData((prev: any) => ({
        ...prev,
        user_head: val,
        client_subs_month_year: val?.payment_details_added === false ? null : prev.client_subs_month_year,
      }));

      setErrors({ ...errors, user_head: "" });
      return;
    }

    // format postal code: add space after 3 characters
    if (name === "postal_code" && val) {
      // remove all spaces first
      val = val.replace(/\s+/g, "").toUpperCase();
      // insert space after 3 characters if length > 3
      if (val.length > 3) {
        val = val.slice(0, 3) + " " + val.slice(3);
      }
    }

    // format Business number
    if (name === "bussiness_number") {
      // remove spaces and RP
      const cleanVal = val.replace(/\s+/g, "").replace("RP", "");
      // const cleanVal = val;

      // create display version
      let displayVal = cleanVal;
      if (cleanVal.length > 9) {
        const firstNine = cleanVal.slice(0, 9);
        const rest = cleanVal.slice(9);
        displayVal = `${firstNine} RP ${rest}`;
      }

      // update what user sees in input
      setDisplayBusinessNumber(displayVal);

      // update your global state with clean (no RP)
      setGlobalClientData({
        ...globleClientData,
        bussiness_number: cleanVal,
      });
      setErrors({ ...errors, [name]: "" });

      return;
    }

    // handle pay schema changes
    if (name === "pay_schema") {
      let updatedPaycheck;

      if (val === "Monthly" || val === "Semi Monthly") {
        updatedPaycheck = 7;
      } else if (val === "Bi Weekly") {
        updatedPaycheck = "Upcoming Friday";
      } else {
        updatedPaycheck = globleClientData?.paycheck;
      }

      setGlobalClientData({
        ...globleClientData,
        pay_schema: val,
        paycheck: updatedPaycheck,

        // reset custom_bi_weekly, bi_weekly_start_date and effective_date fields
        custom_bi_weekly: false,
        bi_weekly_start_date: null,
        effective_date: null,
      });

      setErrors({ ...errors, [name]: "", custom_bi_weekly: "", bi_weekly_start_date: "", effective_date: "" });
      return;
    }

    setGlobalClientData({ ...globleClientData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // add & update client api call
  const submitClientForm = async () => {
    const { isError, errors: validationErrors } = validateClientForm(globleClientData, isEdit, user_id, userRole, isSchemeChanged);

    if (isError || errors.company_logo) {
      setErrors({ ...validationErrors, company_logo: errors.company_logo });
      return;
    }

    setSubmitLoading(true);

    //User Head Wise Head Id SET
    let user_head = "";
    if (userRole == "Admin" && user_id != undefined) {
      user_head = user_id;
    } else if (userRole == "User") {
      user_head = userId;
    } else {
      user_head = globleClientData?.user_head?.id;
    }
    try {
      const formData = new FormData();
      formData.append("company_name", globleClientData.company_name);
      formData.append("email", globleClientData.email);
      formData.append("phone", globleClientData.phone);
      formData.append("user_head", user_head);
      formData.append("pay_schema", globleClientData.pay_schema);
      formData.append("bussiness_number", globleClientData.bussiness_number);
      formData.append("client_charge", globleClientData.client_charge);
      formData.append("address", globleClientData.address);
      formData.append("postal_code", globleClientData.postal_code);
      formData.append("province", globleClientData.province);
      formData.append("city", globleClientData.city);
      formData.append("gst_no", globleClientData.gst_no || "");
      formData.append("pst_no", globleClientData.pst_no || "");
      formData.append("date_format", globleClientData.date_format || "dd/mm/yy");
      formData.append("type", "Client");

      if (globleClientData.company_logo) {
        formData.append("company_logo", globleClientData.company_logo);
      }

      if (globleClientData?.pay_schema === "Monthly" || globleClientData?.pay_schema === "Semi Monthly") {
        formData.append("paycheck", globleClientData?.paycheck);
      }

      if (globleClientData.website_url) {
        formData.append("website_url", globleClientData.website_url);
      }

      if (globleClientData?.pay_schema === "Bi Weekly") {
        formData.append("custom_bi_weekly", globleClientData?.custom_bi_weekly ? "1" : "0");
      }

      if (globleClientData?.custom_bi_weekly === true) {
        formData.append("bi_weekly_start_date", globleClientData?.bi_weekly_start_date ? moment(globleClientData?.bi_weekly_start_date).format("YYYY-MM-DD") : "");
      }

      if (isEdit && isSchemeChanged && globleClientData?.effective_date) {
        formData.append("effective_date", moment(globleClientData?.effective_date).format("YYYY-MM-DD"));
      }

      if (globleClientData?.client_subs_month_year) {
        formData.append("client_subs_month_year", moment(globleClientData?.client_subs_month_year).format("YYYY-MM"));
      }

      if (globleClientData?.client_payroll_starts_from) {
        formData.append("client_payroll_starts_from", moment(globleClientData?.client_payroll_starts_from).format("YYYY-MM"));
      }

      const response = isEdit ? await updateData(UPDATE_CLIENT_DATA, globleClientData?.id, formData) : await postAllData(SAVE_CLIENT_DATA, formData);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideAddEditClientDialog();
        getClientList();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // action body template
  // const actionBodyTemplate = (rowData: any) => (
  //   <div className="actions">
  //     <Button
  //       icon="pi pi-pencil"
  //       tooltip="Edit"
  //       className="common-edit-btn"
  //       tooltipOptions={{ position: "bottom" }}
  //       onClick={() => addEditDialog(rowData)}
  //     />
  //     <Button
  //       icon="pi pi-trash"
  //       tooltipOptions={{ position: "bottom" }}
  //       className="ml-2 p-button-danger common-delete-btn"
  //       tooltip="Delete"
  //       onClick={() => confirmDelete(rowData.id)}
  //     />
  //   </div>
  // );

  // more action template
  const moreActionTemplate = (rowData: any) => (
    <div className="actions">
      {userRole === "User" && (
        <Button
          icon="pi pi-plus"
          className="common-primary-button"
          tooltip="More Actions"
          tooltipOptions={{ position: "bottom" }}
          onClick={(e) => {
            setClickedRow(rowData);
            dropdownButton.current?.toggle(e);
          }}
        />
      )}

      {/* paystub, pay-cycle, t4, pd7a, invoice, sub contractor navigation button */}
      <OverlayPanel ref={dropdownButton}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            padding: "5px",
            width: "160px",
            backgroundColor: "white",
            borderRadius: "10px",
            // position: "absolute",
            top: "-40px",
            right: "5px",
          }}
        >
          <Button
            style={{ fontSize: "13px" }}
            icon="pi pi-arrow-right"
            className="p-button p-button-secondary"
            label="Pay Cycle"
            onClick={() => navigate(`/pay-cycle/${btoa(clickedRow.id)}`)}
          />

          <Button
            style={{ fontSize: "13px" }}
            icon="pi pi-file-pdf"
            className="p-button p-button-secondary"
            label="Pay Stub"
            onClick={() => navigate(`/paystub/${btoa(clickedRow.id)}`)}
          />

          <Button
            style={{ fontSize: "13px" }}
            icon="pi pi-file"
            className="p-button p-button-secondary"
            label="PD7A List"
            onClick={() => navigate(`/pd7a-report/${btoa(clickedRow.id)}`)}
          />

          <Button
            style={{ fontSize: "13px" }}
            icon="pi pi-file-import"
            className="p-button p-button-secondary"
            label="Reports"
            onClick={() => navigate(`/t4-reports/${btoa(clickedRow.id)}`)}
          />

          <Button
            style={{ fontSize: "13px" }}
            icon="pi pi-book"
            className="p-button p-button-secondary"
            label="Invoice List"
            onClick={() =>
              navigate(`/invoice-payee/${btoa(clickedRow.id)}`, {
                state: { clientId: clickedRow?.id },
              })
            }
          />

          <Button
            style={{ fontSize: "13px" }}
            icon="pi pi-file"
            className="p-button p-button-secondary"
            label="Sub Contractor"
            onClick={() =>
              navigate(`/sub-contractor/${btoa(clickedRow.id)}`, {
                state: { clientId: clickedRow?.id },
              })
            }
          />
        </div>
      </OverlayPanel>
    </div>
  );

  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-pencil"
        tooltip="Edit"
        className="common-edit-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => addEditDialog(rowData)}
      />
      <Button
        icon="pi pi-trash"
        tooltipOptions={{ position: "bottom" }}
        className="ml-2 p-button-danger common-delete-btn"
        tooltip="Delete"
        onClick={() => confirmDelete(rowData.id)}
      />
    </div>
  );

  // paycycle redirect template template
  const payCycleTemplate = (rowData: any) => (
    <div className="name">
      <Button className="ml-2 common-primary-button" icon="pi pi-arrow-right" label="" onClick={() => navigate(`/pay-cycle/${btoa(rowData.id)}`)} />
    </div>
  );

  // paystub redirect template template
  const payStubTemplate = (rowData: any) => (
    <div className="name">
      <Button className="ml-2 common-primary-button" icon="pi pi-file-pdf" label="" onClick={() => navigate(`/paystub/${btoa(rowData.id)}`)} />
    </div>
  );

  // action body template
  const pd7aTemplate = (rowData: any) => (
    <div className="name">
      <Button className="ml-2 common-primary-button" icon="pi pi-file" label="" onClick={() => navigate(`/pd7a-report/${btoa(rowData.id)}`)} />
    </div>
  );

  // action body template
  const businessNumberTemplate = (rowData: any) => (
    <div className="name">{rowData?.bussiness_number.slice(0, 9) + " RP " + rowData?.bussiness_number.slice(-4) || "-"}</div>
  );

  // t4 template
  const T4Template = (rowData: any) => (
    <div className="name">
      <Button className="ml-2 common-primary-button" icon="pi pi-file-import" label="" onClick={() => navigate(`/t4-reports/${btoa(rowData.id)}`)} />
    </div>
  );

  // invoice template
  const invoiceTemplate = (rowData: any) => (
    <div className="name">
      <Button
        className="ml-2 common-primary-button"
        icon="pi pi-book"
        label=""
        onClick={() =>
          navigate(`/invoice-list/${btoa(rowData.id)}`, {
            state: { clientId: rowData?.id },
          })
        }
      />
    </div>
  );

  // client detail template
  const clientDetailTemplate = (rowData: any) => {
    return (
      <Link style={{ textDecoration: "underline", color: "blue" }} to={`/clients/${btoa(rowData?.id)}`}>
        {rowData.unique_id}
      </Link>
    );
  };

  //category Filter Template
  const supervisorFilterTemplate = (options: any) => {
    return (
      <Dropdown
        value={supervisor}
        onChange={(e: any) => {
          setSupervisor(e.value);
          options.filterCallback(e.value?.code ?? "", options.index);
        }}
        onFocus={loadSupervisors}
        options={supervisorOptions}
        optionLabel="name"
        placeholder="Select Supervisor"
        className="order-drp"
        showClear
      />
    );
  };

  // filter supervisor template
  const filterBySupervisor = (options: any) => {
    return (
      <Dropdown
        value={supervisor}
        onChange={(e) => {
          setSupervisor(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={supervisorOptions}
        onFocus={loadSupervisors}
        optionLabel="name"
        placeholder="Select Supervisor"
        className="order-drp ml-2 w-15rem"
      />
    );
  };

  //category Filter Template
  const categorySchemaTemplate = (options: any) => {
    return (
      <Dropdown
        // filter
        value={category}
        onChange={(e: any) => {
          setCategory(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={paySchemaOptions}
        optionLabel="name"
        placeholder="Category"
        className="order-drp"
      ></Dropdown>
    );
  };

  // cycle status filter template
  const cycleStatusFilterTemplate = (options: any) => {
    return (
      <Dropdown
        // filter
        value={cycleStatus}
        onChange={(e: any) => {
          setCycleStatus(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={cycleStatusDropdown}
        optionLabel="name"
        placeholder="Status"
        className="order-drp"
      ></Dropdown>
    );
  };

  // cycle status template
  const cycleStatusTemplate = (rowData: any) => {
    let statusClass: any = rowData?.cycle_status === "Not Added" ? "warning" : "success";
    return <Badge severity={statusClass} value={rowData.cycle_status} style={{ width: "fit-content" }}></Badge>;
  };

  // date filter template
  const dateFilterTemplate = (options: any) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.value)}
        view="month"
        dateFormat="mm/yy"
        placeholder="Select Date"
        showIcon
      />
    );
  };
  return (
    <>
      <AppBreadcrumb
        currentMenu="Clients"
        pageName=" List"
        pageTitle={user_id ? "User Details" : "Client List"}
        goToPage={!!user_id}
      // {...(id && { goToPage: true })}
      />
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo relative">
            {userDetails && (
              <>
                <div className="grid">
                  <div className="col-12 md:col-12">
                    <div className="grid p-fluid">
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Name:</label>
                        <div>
                          {userDetails?.first_name || "-"} {userDetails?.last_name || "-"}
                        </div>
                      </div>
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Email:</label>
                        <div>{userDetails?.email || "-"}</div>
                      </div>
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Phone:</label>
                        <div>{userDetails?.phone || "-"}</div>
                      </div>
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Postal Code:</label>
                        <div>{userDetails?.postal_code || "-"}</div>
                      </div>
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>GST Number:</label>
                        <div>{userDetails?.gst_no || "-"}</div>
                      </div>
                      <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                        <label style={{ fontWeight: "bold" }}>Address:</label>
                        <div>{userDetails?.address || "-"}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <h5 className="mb-3">Clients List</h5>
              </>
            )}
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={clientList}
                showGridlines
                dataKey="id"
                responsiveLayout={"scroll"}
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={clientList.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Clients"}
                emptyMessage="No Clients Found"
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                globalFilterFields={["unique_id", "company_name", "email", "phone", "address", "bussiness_number", "pay_schema"]}
                removableSort
              >
                {clientListCol.map((col: any, i: any) => {
                  if (col.field === "name") {
                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterElement={globalNameFilterTemplate} />;
                  } else if (col.field === "company_name") {
                    return <Column key={col.field} field={col.field} header={col.header} filter filterElement={globalNameFilterTemplate} />;
                  } else if (col.field === "email") {
                    return <Column key={col.field} field={col.field} header={col.header} filter filterElement={globalNameFilterTemplate} />;
                  } else if (col.field === "phone") {
                    return <Column key={col.field} field={col.field} header={col.header} filter filterElement={globalNameFilterTemplate} />;
                  } else if (col.field === "address") {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  } else if (col.field === "client_subs_month_year") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={dateMonthYearTemplate}
                        dataType="date"
                        filter
                        filterElement={dateFilterTemplate}
                      />
                    );
                  } else if (col.field === "pay_schema") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        filter
                        filterField="pay_schema"
                        filterElement={categorySchemaTemplate}
                      />
                    );
                  } else if (col.field === "bussiness_number") {
                    return <Column key={col.field} field={col.field} header={col.header} body={businessNumberTemplate} />;
                  } else if (col.field === "pd7a") {
                    return <Column key={col.field} field={col.field} header={col.header} body={pd7aTemplate} />;
                  } else if (col.field === "paystub_pdf") {
                    return <Column key={col.field} field={col.field} header={col.header} body={payStubTemplate} />;
                  } else if (col.field === "t4") {
                    return <Column key={col.field} field={col.field} header={col.header} body={T4Template} />;
                  } else if (col.field === "invoice") {
                    return <Column key={col.field} field={col.field} header={col.header} body={invoiceTemplate} />;
                  } else if (col.field === "unique_id") {
                    return <Column key={col.field} field={col.field} header={col.header} body={clientDetailTemplate} />;
                  } else if (col.field === "action") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else if (col.field === "more_action") {
                    return <Column key={col.field} field={col.field} header={col.header} body={moreActionTemplate} />;
                  } else if (col.field === "paystub") {
                    return <Column key={col.field} field={col.field} header={col.header} body={payCycleTemplate} />;
                  } else if (col.field === "cycle_status") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={cycleStatusTemplate}
                        filter
                        filterField="cycle_status"
                        filterElement={cycleStatusFilterTemplate}
                      />
                    );
                  } else if (col.field === "user") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={(rowData) => userTemplate(rowData.user)}
                        filterField="user"
                        filter
                        filterElement={supervisorFilterTemplate}
                      />
                    );
                  } else if (col.field === "email") {
                    return <Column key={col.field} field={col.field} header={col.header} filterField="email" filter body={globalFieldTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {clientListCol.map((col: any) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}

            {pageLoad === false && user_id && <Loader />}
            {pageLoad === false && userRole === "User" && <Loader />}
          </Card>
        </div>
      </div>
      {/* Add/Edit Dialog */}
      <Dialog
        visible={addDeleteClientDialog}
        style={{ width: "800px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={isEdit ? "Edit Client" : "Add Client"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideAddEditClientDialog} />
            <Button
              label="Submit"
              icon="pi pi-check"
              className="common-primary-button"
              onClick={submitClientForm}
              loading={submitLoading}
              disabled={isEdit && isSchemeChanged && !paySchemaConfirmation}
            />
          </div>
        }
        onHide={hideAddEditClientDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* Company Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="company_name">Company Name *</label>
            <div className="input-effect-div">
              <InputText
                value={globleClientData.company_name || ""}
                name="company_name"
                autoComplete="off"
                placeholder="Enter Company Name"
                onChange={(e) => onInputChange(e, "company_name")}
                className={errors["company_name"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["company_name"]}</small>
          </div>

          {/* Company Logo */}
          <div className="field col-12 md:col-6">
            <label htmlFor="company_logo">Company Logo</label>
            <div className="input-effect-div" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <InputText
                type="file"
                name="company_logo"
                autoComplete="off"
                onChange={(e) => onInputChange(e, "company_logo")}
                className={errors["company_logo"] && "p-invalid"}
                style={{ color: globleClientData?.company_logo && typeof globleClientData.company_logo === 'string' ? 'transparent' : 'inherit' }}
                accept="image/*"
              />
              {globleClientData?.company_logo && typeof globleClientData.company_logo === 'string' && (
                <div style={{
                  position: 'absolute',
                  left: '110px',
                  pointerEvents: 'none',
                  color: '#495057',
                  fontSize: '13px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: 'calc(100% - 120px)'
                }}>
                  {globleClientData.company_logo.split('/').pop()}
                </div>
              )}
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["company_logo"]}</small>
            <div className="mt-1" style={{ fontSize: '12px', color: 'red' }}>
              Please upload a transparent logo (Max size: 2MB).
            </div>
          </div>

          {/* Email */}
          <div className="field col-12 md:col-6">
            <label htmlFor="email">Email *</label>
            <div className="input-effect-div">
              <InputText
                value={globleClientData.email || ""}
                name="email"
                autoComplete="off"
                placeholder="Enter Email"
                onChange={(e) => onInputChange(e, "email")}
                className={errors["email"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["email"]}</small>
          </div>
          {/* Phone */}
          <div className="field col-12 md:col-6">
            <label htmlFor="phone">Phone *</label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <span className="font-bold p-inputgroup-addon">+1</span>
              <InputText
                value={globleClientData.phone || ""}
                name="phone"
                autoComplete="off"
                placeholder="Enter Phone Number"
                onChange={(e) => onInputChange(e, "phone")}
                className={errors["phone"] && "p-invalid"}
                keyfilter="pint"
                maxLength={10}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["phone"]}</small>
          </div>

          {/* Website url */}
          <div className="field col-12 md:col-6">
            <label htmlFor="website_url">Enter Website Url </label>
            <div className="input-effect-div">
              <InputTextarea
                rows={1}
                value={globleClientData.website_url || ""}
                name="website_url"
                autoComplete="off"
                placeholder="Enter Website Url"
                onChange={(e) => onInputChange(e, "website_url")}
                className={errors["website_url"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["website_url"]}</small>
          </div>

          {/* Buisness Number */}
          <div className="field col-12 md:col-6">
            <label htmlFor="bussiness_number">Business No *</label>
            <div className="input-effect-div">
              <InputText
                value={displayBusinessNumber || ""}
                name="bussiness_number"
                autoComplete="off"
                placeholder="Enter Business Number"
                maxLength={17}
                keyfilter={"pint"}
                onChange={(e) => onInputChange(e, "bussiness_number")}
                className={errors["bussiness_number"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["bussiness_number"]}</small>
          </div>

          {/* GST Number */}
          <div className="field col-12 md:col-6">
            <label htmlFor="gst_no">GST Number </label>
            <div className="input-effect-div">
              <InputText
                value={globleClientData.gst_no || ""}
                name="gst_no"
                autoComplete="off"
                placeholder="Enter GST Number"
                onChange={(e) => onInputChange(e, "gst_no")}
                className={errors["gst_no"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["gst_no"]}</small>
          </div>

          {/* PST Number */}
          <div className="field col-12 md:col-6">
            <label htmlFor="pst_no">PST Number</label>
            <div className="input-effect-div">
              <InputText
                value={globleClientData.pst_no || ""}
                name="pst_no"
                autoComplete="off"
                placeholder="Enter PST Number"
                onChange={(e) => onInputChange(e, "pst_no")}
              />
              <span className="focus-bg"></span>
            </div>
          </div>

          {/* Supervisor */}
          {!user_id && userRole != "User" && (
            <div className="field md:col-6 col-12">
              <label htmlFor="type">Supervisor *</label>
              <Dropdown
                value={globleClientData.user_head || ""}
                onChange={(e) => onInputChange(e, "user_head")}
                options={userHead}
                disabled={isEdit}
                optionLabel="name"
                placeholder="Select Supervisor"
                className="order-drp"
              />
              <small className="p-invalid-txt">{errors["user_head"]}</small>
            </div>
          )}

          {/* pay scheme */}
          <div className="field md:col-6 col-12">
            <label htmlFor="paySchema">Pay Scheme *</label>
            <Dropdown
              value={globleClientData.pay_schema || ""}
              onChange={(e) => onInputChange(e, "pay_schema")}
              options={paySchemaOptions}
              optionLabel="name"
              id={"paySchema"}
              placeholder="Select Payschema"
              className="order-drp"
            />
            <small className="p-invalid-txt">{errors["pay_schema"]}</small>
          </div>

          {/* check box */}
          {globleClientData?.pay_schema === "Bi Weekly" && !isEdit && (
            <div className="flex flex-wra justify-content-between field align-items-center col-12 md:col-6">
              <div className="lg:mt-5 field-checkbox">
                <Checkbox
                  inputId="checkOption1"
                  name="custom_bi_weekly"
                  checked={globleClientData.custom_bi_weekly === true}
                  onChange={(e) => onInputChange(e, "custom_bi_weekly")}
                />
                <label htmlFor="checkOption3">Enter Custom Cycle Start Date</label>
              </div>
            </div>
          )}

          {/* Custom bi weekly Cycle Start Date */}
          {globleClientData?.custom_bi_weekly === true && globleClientData?.pay_schema === "Bi Weekly" && !isEdit && (
            <div className="field col-12 md:col-6">
              <label htmlFor="date">Bi Weekly Cycle Start Date *</label>
              <div className="input-effect-div">
                <Calendar
                  value={globleClientData.bi_weekly_start_date ? moment(globleClientData.bi_weekly_start_date, "YYYY-MM-DD").toDate() : null}
                  dateFormat="dd/mm/yy"
                  placeholder="Enter Cycle Start Date"
                  onChange={(e) => onInputChange(e, "bi_weekly_start_date")}
                  showIcon
                />
                <span className="focus-bg"></span>
              </div>
              <small className="p-invalid-txt">{errors["bi_weekly_start_date"]}</small>
            </div>
          )}

          {/* client Payment */}
          <div className="field col-12 md:col-6">
            <label htmlFor="client_charge">Client Payment *</label>
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <span className="font-bold p-inputgroup-addon">$</span>
                <InputNumber
                  value={globleClientData.client_charge || ""}
                  onChange={(e) => onInputChange(e, "client_charge")}
                  placeholder="Enter Client Payment"
                  name="client_charge"
                  disabled={true}
                  className={errors["client_charge"] && "p-invalid"}
                  // minFractionDigits={2}
                  maxFractionDigits={2}
                  mode="decimal"
                  useGrouping={false}
                />
              </div>
            </form>

            <small className="p-invalid-txt">{errors["client_charge"]}</small>
          </div>

          {/* Pay scheme effective date */}
          {isEdit && isSchemeChanged && (
            <div className="field col-12 md:col-6">
              <label htmlFor="effective_date">Effective Date *</label>
              <div className="input-effect-div">
                <Calendar
                  id="effective_date"
                  value={globleClientData.effective_date ? moment(globleClientData.effective_date, "YYYY-MM-DD").toDate() : null}
                  dateFormat="dd/mm/yy"
                  placeholder="Select Effective Date"
                  onChange={(e) => onInputChange(e, "effective_date")}
                  showIcon
                />
                <span className="focus-bg"></span>
              </div>
              <small className="p-invalid-txt">{errors["effective_date"]}</small>
            </div>
          )}

          {isEdit && isSchemeChanged && (
            <div className="field col-12 field-checkbox">
              <Checkbox
                inputId="paySchemaConfirmation"
                checked={paySchemaConfirmation}
                onChange={(e: any) => setPaySchemaConfirmation(e.checked)}
              />
              <label
                htmlFor="paySchemaConfirmation"
                className="ml-2 mb-0 font-semibold"
                style={{ color: "red" }}
              >
                All existing reports, PD7A forms, and pay stubs will remain unchanged for periods before the selected effective date. The updated pay scheme will apply only from the effective date onward.
              </label>
            </div>
          )}

          {/* client payroll start date */}
          <div className="field md:col-6 col-12">
            <label htmlFor="type">{`Client Payroll Starts From ${isEdit ? `` : `*`}`}</label>

            <Calendar
              value={globleClientData?.client_payroll_starts_from}
              onChange={(e) => onInputChange(e, "client_payroll_starts_from")}
              view="month"
              dateFormat="mm/yy"
              disabled={isEdit}
              // minDate={clientPaymentDates(globleClientData)}
              minDate={moment(clientCurrentMonthYear, "YYYY-MM-DD").toDate()}
              placeholder="Select Month/Year"
            />
            <small className="p-invalid-txt">{errors["client_payroll_starts_from"]}</small>
          </div>

          {/* client payment start date */}
          {userRole != "User" && (
            <div className="field md:col-6 col-12">
              <label htmlFor="type">
                Client Payment Starts From.{" "}
                {globleClientData?.user_head?.payment_details_added === undefined && !user_id && (
                  <small className="p-invalid-tx">(To Enable Field Select Supervisor.)</small>
                )}
              </label>

              <Calendar
                value={globleClientData?.client_subs_month_year}
                onChange={(e) => onInputChange(e, "client_subs_month_year")}
                view="month"
                dateFormat="mm/yy"
                // disabled={
                //   globleClientData?.user_head?.payment_details_added === false ||
                //   (globleClientData?.user_head?.payment_details_added === undefined && !user_id)
                // }
                disabled={
                  globleClientData?.user_head?.payment_details_added === false ||
                  (globleClientData?.user_head?.payment_details_added === undefined && !user_id) ||
                  globleClientData?.client_payroll_starts_from == null ||
                  disableClientPaymentStartDateOnEdit
                }
                // minDate={clientPaymentDates(globleClientData)}
                minDate={clientPaymentMinDate}
                placeholder="Select Month/Year"
              />
              <small className="p-invalid-txt">{errors["client_subs_month_year"]}</small>

              {/* display note that user has not added card details */}
              {globleClientData?.user_head?.payment_details_added === false && (
                <small className="p-invalid-txt">Supervisor has not added card details yet.</small>
              )}
            </div>
          )}

          {/* pay Cheque  */}
          <div className="field col-12 md:col-6">
            <label htmlFor="paycheck">
              Pay Cheque Days*
              {isEdit ? (
                <>
                  <i
                    className="pi pi-info-circle"
                    data-pr-tooltip={`Only paycheck dates after the current cycle will be updated.\nIf the current cycle is not added, its paycheck date will also be updated.`}
                    data-pr-position="right"
                    style={{
                      marginLeft: "6px",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  ></i>
                  <Tooltip target=".pi-info-circle" />{" "}
                </>
              ) : (
                ""
              )}
            </label>
            <div className="input-effect-div">
              <InputText
                value={!window.cn(globleClientData.paycheck) ? globleClientData.paycheck : ""}
                onChange={(e) => onInputChange(e, "paycheck")}
                keyfilter="int"
                name="paycheck"
                autoComplete="off"
                disabled={globleClientData?.pay_schema === "Bi Weekly"}
                placeholder="Pay Cheque Days"
                className={errors["paycheck"] && "p-invalid"}
              />

              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["paycheck"]}</small>
          </div>

          {/* Postal Code */}
          <div className="field col-12 md:col-6">
            <label htmlFor="postal_code">Postal Code *</label>
            <div className="input-effect-div">
              <InputText
                value={globleClientData.postal_code || ""}
                name="postal_code"
                placeholder="Enter Postal Code"
                autoComplete="off"
                onChange={(e) => onInputChange(e, "postal_code")}
                className={errors["postal_code"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["postal_code"]}</small>
          </div>

          <div className="field md:col-6 col-12">
            <label htmlFor="province">Select Province *</label>
            <Dropdown
              value={globleClientData.province || ""}
              onChange={(e) => onInputChange(e, "province")}
              options={provinces}
              placeholder="Select Province"
              className={errors["province"] ? "p-invalid" : ""}
            />
            <small className="p-invalid-txt">{errors["province"]}</small>
          </div>

          {/* city */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">City *</label>
            <div className="input-effect-div">
              <InputText
                value={globleClientData.city || ""}
                name="city"
                placeholder="Enter City"
                autoComplete="off"
                onChange={(e) => onInputChange(e, "city")}
                className={errors["city"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["city"]}</small>
          </div>

          {/* Date Format */}
          <div className="field col-12 md:col-6">
            <label htmlFor="date_format">Select Date Format for invoice</label>
            <Dropdown
              id="date_format"
              value={globleClientData.date_format || "dd/mm/yyyy"}
              options={[
                { label: "DD/MM/YYYY", value: "dd/mm/yyyy" },
                { label: "YYYY/MM/DD", value: "yyyy/mm/dd" },
                { label: "MM/DD/YYYY", value: "mm/dd/yyyy" },
              ]}
              onChange={(e) => onInputChange(e, "date_format")}
              optionLabel="label"
              optionValue="value"
              placeholder="Select Date Format"
            />
          </div>

          {/* Address */}
          {userRole == "User" ? (
            <div className="field col-12 md:col-12">
              <label htmlFor="address">Address *</label>
              <div className="input-effect-div">
                <InputText
                  value={globleClientData.address || ""}
                  name="address"
                  autoComplete="off"
                  maxLength={30}
                  placeholder="Enter Address"
                  onChange={(e) => onInputChange(e, "address")}
                  className={errors["address"] && "p-invalid"}
                />
                <span className="focus-bg"></span>
              </div>
              <small className="p-invalid-txt">{errors["address"]}</small>
            </div>
          ) : (
            <div className="field col-12 md:col-12">
              <label htmlFor="address">Address *</label>
              <div className="input-effect-div">
                <InputTextarea
                  rows={3}
                  value={globleClientData.address || ""}
                  name="address"
                  autoComplete="off"
                  maxLength={30}
                  placeholder="Enter Address"
                  onChange={(e) => onInputChange(e, "address")}
                  className={errors["address"] && "p-invalid"}
                />
                <span className="focus-bg"></span>
              </div>
              <small className="p-invalid-txt">{errors["address"]}</small>
            </div>
          )}


        </div>
      </Dialog>
      {/* Delete Dialog */}
      <Dialog
        visible={deleteDialog}
        header="Delete Client"
        draggable={false}
        className="mx-3 lg:mx-0"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideDeleteDialog} />
            <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteClient} loading={submitLoading} />
          </div>
        }
        onHide={hideDeleteDialog}
      >
        <div className="flex align-items-center justify-content-start">
          <i className="mr-3 pi pi-exclamation-triangle delete-triangle" style={{ fontSize: "2rem" }} />
          <span className="delete-dialog-note">Are you sure you want to delete this Client?</span>
        </div>
      </Dialog>

      {/* Dialog to display information about bank card details added by user or not */}
      <Dialog
        header={userRole === "Admin" ? "Bank Details Not Added By User" : "Add Card Details"}
        visible={userCardInfoDialog}
        onHide={() => {
          setUserCardInfoDialog(false);
        }}
        modal
        draggable={false}
        dismissableMask={false}
        className="bank-details-modal"
        style={{ width: "30rem" }}
        footer={<div></div>}
      >
        {userRole === "Admin" ? (
          <div className="flex align-items-center justify-content-start">
            <i className="mr-3 pi pi-exclamation-triangle delete-triangle" style={{ fontSize: "2rem" }} />
            <span className="delete-dialog-note">It looks like user haven't added bank details.</span>
          </div>
        ) : (
          <p className="m-0 text-center">It looks like you haven't added your card details yet.</p>
        )}

        <div className="flex justify-content-center mt-4">
          {userRole === "User" && (
            <button
              className="bank-modal-btn"
              onClick={() => {
                setUserCardInfoDialog(false);
                setShowPaymentModal(true);
              }}
            >
              Add Card Details
            </button>
          )}
        </div>
      </Dialog>

      {/* dialog for stripe card detail form */}
      <Dialog
        header="Add Card Details"
        visible={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        modal
        draggable={false}
        dismissableMask={false}
        style={{ width: "35rem" }}
        footer={<div></div>}
      >
        <UpdatePaymentMethod customerId={userData?.customer_id} onSuccess={() => setShowPaymentModal(false)} getApiCall={() => getClientList()} />
      </Dialog>
    </>
  );
};
export default ManageClients;
